import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";
import { useAppSelector } from "@redux/hooks";
import type { SessionState } from "@user-management-context/write/application/use-cases/session/session-reducer";

const selectSession = createSelector([(state: AppState) => state.shared.session], (session): SessionState => session);

export const useSession = (): SessionState => useAppSelector(selectSession);
